import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';

@Injectable({
  providedIn: 'root'
})
export class AssignedObjectionSuggestionListService {

  constructor(public httpClient:HttpClient) { }

  async objectionSuggestionList() {
   
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadOSForInternalUser, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


  async objectionSuggestionListV2(page: number, size: number) {
   
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadOSForInternalUserV2+`?page=${page}&size=${size}`, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
}
